<template>
  <b-row align-h="center">
    <b-col lg="4" v-if="!isAllLoaded()">
      <div class="text-center">
        <b-card>
          <b-spinner label="Spinning" class="icdl-blue-inverse"></b-spinner>
          <b-card-text>
            {{ loading_message }}
          </b-card-text>
        </b-card>

      </div>
    </b-col>
    <b-col lg="10" v-else>
      <b-alert v-if="is_submitted && is_valid" show variant="success">Votre inscription a bien été prise en compte.<br>

        <div v-if="is_editable" class="container-fluid text-center">
          Votre centre vous permet de personnaliser votre parcours d'évaluation en cliquant sur le bouton ci-dessous.<br>
          <b-link class="btn icdl-blue" :to="parcours_link">Choisir mes tests d'évaluation</b-link>
        </div>
        <div v-else>
          <span v-if="auto_validation">
            Un email vous permettant de vous connecter à la plateforme candidat ICDL vous a été envoyé.
          </span>
          <span v-else>
            Un email vous permettant de vous connecter à la plateforme candidat ICDL vous sera envoyé quand votre centre habilité ICDL aura validé votre inscription.
          </span>
        </div>
      </b-alert>
      <b-alert v-else-if="is_submitted && !is_valid" show variant="danger">{{response_message}}</b-alert>
      <b-card v-if="(!is_submitted || !is_valid) && is_submit_loaded" title="Formulaire d'inscription ICDL" >
        <b-card-text>
          Merci de renseigner les informations ci-dessous.
        </b-card-text>
        <b-form @submit="onSubmit">
          <b-row>
            <b-col lg="6">
              <div>
                <h5>Informations obligatoires</h5>
                <b-form-group v-for="(mandatory_field,index) in mandatory_fields" :label="mandatory_field.label" :label-cols-lg="mandatory_field.label_cols" :key="index">
                  <b-form-input v-if="mandatory_field.type == 'input'" :id="mandatory_field.id"  v-model="mandatory_field.model" :type="mandatory_field.inputType" :placeholder="mandatory_field.placeholder" :required="mandatory_field.required"></b-form-input>
                  <b-form-radio-group v-else-if="mandatory_field.type == 'radio' && mandatory_field.id == 'gender'" :id="mandatory_field.id" v-model="mandatory_field.model" :options="mandatory_field.options" :required="true"></b-form-radio-group>
                  <b-form-radio-group v-else-if="mandatory_field.type == 'radio' && mandatory_field.id != 'gender'" v-on:change="cancelBirthPlace" :id="mandatory_field.id" v-model="birth_country" :options="mandatory_field.options" :required="true"></b-form-radio-group>

                </b-form-group>
                <b-form-group>
                  <multi-select v-if="birth_country == 'france'"
                                @search-change="getInseeList"
                                label="text"
                                v-model="selected_birth_place"
                                :id="'city_select'"
                                placeholder="Sélectionnez une ville"
                                open-direction="bottom"
                                :options="birth_places"
                                :loading="is_birth_place_loading"
                                :searchable="true"
                                :internal-search="false"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :max-height="600"
                                :show-no-results="true"
                                :selectLabel="null"
                                :required="true"
                  >
                    <template v-slot:noOptions>
                      Tapez une lettre
                    </template>
                    <template v-slot:noResult>
                      <div v-if="is_birth_place_loading">Chargement des résultats</div>
                      <div v-else>Aucune ville trouvée</div>
                    </template>
                  </multi-select>
                  <multi-select v-else
                                @search-change="getInseeList"
                                v-model="selected_birth_place"
                                label="text"
                                :id="'country_select'"
                                placeholder="Sélectionnez un pays"
                                open-direction="bottom"
                                :options="birth_places"
                                :loading="is_birth_place_loading"
                                :searchable="true"
                                :internal-search="false"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :max-height="600"
                                :show-no-results="true"
                                :selectLabel="null"
                                :required="true">
                    <template v-slot:noOptions>
                      Tapez une lettre
                    </template>
                    <template v-slot:noResult>
                      <div v-if="is_birth_place_loading">Chargement des résultats</div>
                      <div v-else>Aucun pays trouvé</div>
                    </template>

                  </multi-select>
                </b-form-group>
              </div>
            </b-col>
            <b-col lg="6">
              <h5>Informations optionnelles</h5>
              <b-form-group v-for="(field,index) in optionnal_fields" :label="field.label" :label-cols-lg="field.label_cols" :key="index">
                <b-form-input v-if="field.type == 'input'" :id="field.id" v-model="field.model" :type="field.inputType" :placeholder="field.placeholder" :required="field.required"></b-form-input>
                <b-form-radio-group v-else-if="field.type == 'radio'" :id="field.id" v-model="field.model" :options="field.options"></b-form-radio-group>
                <multi-select v-else-if="field.type == 'select'" label="text"  track-by="value" v-model="field.model" :options="field.options" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="field.placeholder"></multi-select>
              </b-form-group>
            </b-col>
            <b-button block size="lg" class="icdl-blue" type="submit">Envoyer mon inscription</b-button>
          </b-row>
        </b-form>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FormInscription',
  props: {
    msg: String,
    id_site:String,
    is_editable:Boolean,
    form_link:String,
    auto_validation:Boolean
  },
  data(){
    return{
        parcours_link: null,
        id_user:null,
        is_submit_loaded:true,
        response_message: '',
        is_submitted: false,
        is_valid: false,
        is_job_loaded:false,
        is_studies_loaded:false,
        birth_country:"france",
        selected_birth_place:null,
        is_birth_place_loading:false,
        birth_places:[],
        api:process.env.VUE_APP_API_URL,
        loading_message: 'Chargement des données',
        form_model:{
            last_name: ''
        },
        mandatory_fields: [
            {
                type: "input",
                id: "email",
                label:"",
                inputType: "email",
                model: '',
                placeholder: "e-mail",
                // readonly: this.$helper.isLegacy,
                required: true,
            },
            {
                type: "radio",
                id: "gender",
                label:"Genre",
                model:'',
                label_cols:2,
                options: [
                  { text: 'Homme', value: 'MALE' },
                  { text: 'Femme', value: 'FEMALE' },
                ],
                required: true,
            },
            {
                type: "input",
                id: "last_name",
                label:"",
                inputType: "text",
                model: '',
                placeholder: "Nom de famille",
                // readonly: this.$helper.isLegacy,
                required: true,
            },
            {
                type: "input",
                id: "birth_name",
                inputType: "text",
                model: '',
                placeholder: "Nom de naissance (obligatoire si différent du nom de famille)",
                // readonly: this.$helper.isLegacy,
                required: false,
            },
            {
                type: "input",
                id: "first_name",
                label:"",
                inputType: "text",
                model: '',
                placeholder: "Prénom",
                // readonly: this.$helper.isLegacy,
                required: true,
            },
            {
                type: "input",
                id: "birth_date",
                label:"",
                inputType: "date",
                model: '',
                placeholder: "Date de naissance",
                // readonly: this.$helper.isLegacy,
                required: true,
            },
            {
                type: "radio",
                model:'france',
                id: "bp-radio",
                label:"Lieu de naissance",
                label_cols:3,
                options: [
                    { text: 'France', value: 'france' },
                    { text: 'Hors France', value: 'etranger' },
                ],
                required: true,
            },

        ],
        optionnal_fields:[
            {
                type: "input",
                id: "telephone",
                inputType: "tel",
                model: '',
                placeholder: "Téléphone (Recommandé)",
                // readonly: this.$helper.isLegacy,
                required: false,
            },
            {
                type: "input",
                id: "address",
                inputType: "text",
                model: '',
                placeholder: "Adresse",
                // readonly: this.$helper.isLegacy,
                required: false,
            },
            {
                type: "input",
                id: "postalCode",
                inputType: "text",
                model: '',
                placeholder: "Code postal",
                // readonly: this.$helper.isLegacy,
                required: false,
            },
            {
                type: "input",
                id: "city",
                inputType: "text",
                model: '',
                placeholder: "Ville",
                // readonly: this.$helper.isLegacy,
                required: false,
            },
        ]
    }
  },
  methods: {
      async getInseeList(query) {

          this.is_birth_place_loading = true;
          this.birth_places = [];
          axios
              .post(process.env.VUE_APP_API_URL+'/public/insee_list', {
                  "search": query,
                  "country": this.birth_country
              })
              .then((response) => {
                  this.birth_places = response.data;
                  this.is_birth_place_loading = false;
              })
      },
      cancelBirthPlace(){
          this.selected_birth_place = null;
      },
      isAllLoaded(){
        return this.is_job_loaded && this.is_studies_loaded && this.is_submit_loaded;
      },
      onSubmit(event) {
          event.preventDefault();

          if(this.selected_birth_place == null)
          {
              this.is_valid = false;
              this.is_submitted = true;
              this.response_message = 'Merci de renseigner votre lieu de naissance.';
          }
          else{
              this.is_submit_loaded = false;
              this.loading_message = "Envoi de vos informations en cours.";
              let form = {};
              // console.debug(this.optionnal_fields)

              Object.values(this.mandatory_fields).forEach(field=>{
                  let obj ={};
                  if(field.id != 'bp-radio' && field.model.length)
                  {
                      form[field.id] = field.model;
                  }

              });

              Object.values(this.optionnal_fields).forEach(field=>{
                  let obj ={};
                  if(typeof field.model === 'object')
                  {
                      let val = field.model.value;
                      if(val.length)
                      {
                          form[field.id] = val;
                      }
                  }
                  else
                  {
                      if(field.model.length)
                      {
                          form[field.id] = field.model;
                      }
                  }
              });
              form['birthPlace'] = this.selected_birth_place.value;
              form['form_link'] = localStorage.id_formlink;
              form['center'] = localStorage.id_site;
              if(this.access_token == null || this.token_timestamp + 3600000 > Date.now()) {
                  this.$parent.getAccessToken();
              }
              let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
              axios
                  .post(process.env.VUE_APP_API_URL+'/formlink/inscription/add', form,{"headers":headers})
                  .then((response) => {
                      console.debug(response.data);
                      this.id_user = response.data.shift().id_user;
                      let validation = '';
                      if(this.auto_validation)
                      {
                          validation = "auto"
                      }
                      else{
                          validation = "of"
                      }
                      this.parcours_link = '/'+this.form_link+'/'+this.id_user+'/'+validation+'/parcours';
                      this.is_submit_loaded = true;
                      this.is_valid = true;
                      this.is_submitted = true;
                  }).catch((error)=> {
                  console.debug(error.response)
                  this.is_submit_loaded = true;
                  this.is_submitted = true;
                  this.response_message = this.$t('form_errors.'+error.response.data.error.exception.shift().message);
              });
          }

      },
  },
  mounted () {
      axios
          .get(process.env.VUE_APP_API_URL+'/public/enum/job_enum')
          .then((response) => {
              let jobs = response.data;
              let jobs_options = [];
              Object.entries(jobs).forEach(entry=>{
                  const [key, val] = entry;
                  jobs_options.push({value:key,text:this.$t('jobs_options.'+val)});

              });
              let job_select = {
                  type: "select",
                  id: "job",
                  inputType: "text",
                  model: '',
                  placeholder: "Situation Professionnelle",
                  options: jobs_options,
                  required: false,
              };
              this.optionnal_fields.push(job_select);
              this.is_job_loaded = true;

          });
      axios
          .get(process.env.VUE_APP_API_URL+'/public/enum/studies_enum')
          .then((response) => {
              let studies = response.data;
              let studies_options = [];
              Object.entries(studies).forEach(entry=>{
                  const [key, val] = entry;
                  studies_options.push({value:key,text:this.$t('studies_options.'+val)});

              });
              let studies_select = {
                  type: "select",
                  id: "studyLevel",
                  inputType: "text",
                  model: '',
                  placeholder: "Niveau d'étude",
                  options: studies_options,
                  required: false,
              };
              this.optionnal_fields.push(studies_select);
              this.is_studies_loaded = true;
          });

  }
}
</script>
